import script from "./GeoItemSearchJunkaiTenkenReportTenkenData.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeoItemSearchJunkaiTenkenReportTenkenData.vue?vue&type=script&setup=true&lang=ts"

import "./GeoItemSearchJunkaiTenkenReportTenkenData.vue?vue&type=style&index=0&id=71468cc6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71468cc6"]])

export default __exports__